import React from 'react'
import System from 'src/helper/system';
import { __remove, __set } from 'src/store/axios_indicator';

const OrderReleasesPopup = (props) => {
    const { SetStatus, data: { poNumber, doNum } } = props;
    const { translation: t } = System;

    return (
        <>
            <div className="avnet-modal modal-600">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    <button type="button" className="close py-3" data-dismiss="modal" onClick={(() => SetStatus(false))}>×</button>
                    <div className="modal-header justify-content-center mt-0">
                        <h3 className="modal-title m-auto">{t('viewAllReleases')}</h3>
                    </div>

                    {/* Modal body */}
                    <div className="modal-body py-0">
                        <p className='mb-5 font-13 font-arial text-center'>{t('hereReleasesForPONumber')} <span><strong>{poNumber}.</strong></span></p>
                        <div className='ms-4 me-4'>
                            <div className='bs5 row'>
                                {doNum?.map((val, i) => (
                                    <div className='col-md-3' key={i}>
                                        <p className='mb-2 font-13 font-arial text-center'>{val}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer justify-content-center mt-5 d-flex">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-secondary btn-sm w145 text-uppercase" data-dismiss="modal" onClick={() => {
                                SetStatus(false)
                            }}>
                                {t('close')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default OrderReleasesPopup